import React from 'react'
import { CloseButton, Form } from 'react-bootstrap'
import styled from 'styled-components'
import { colors } from '../../styles/colors'
import { useLocalReturnsState } from '../../stores/LocalReturnsProvider'
import { useTranslation } from 'react-i18next'
import { formatedDate } from '../../utils/formatedDate'

const StyledWrapper = styled.div`
  //display: flex;
  flex-grow: 1;
  padding: 4px;

  .form-label {
    margin-bottom: 5px;
  }
`

const StyledItem = styled.div`
  margin: 5px;
  padding: 6px 10px;
  border: 1px solid ${colors.borderColor};
  border-radius: 8px;

  .close {
    margin-left: 15px;
  }
`

const StyledItemWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -5px;
`

const ActiveTableFilters = () => {
  const {
    officeFilter, setOfficeFilter, officeName,
    costCenterFilter, setCostCenterFilter, costCenterName,
    storehouseFilter, setStorehouseFilter,
    startDateFilter, setStartDateFilter,
    endDateFilter, setEndDateFilter} = useLocalReturnsState()

  const { t } = useTranslation()
  const formatedStartDate = () => {
    if(!!startDateFilter)
    {
        if (formatedDate(startDateFilter)) return formatedDate(startDateFilter)
    }
    return "";
  }
  const formatedEndDate = () => {
    if(!!endDateFilter)
    {
        if (formatedDate(endDateFilter)) return formatedDate(endDateFilter)
    }
    return "";
  }
  const startDate = formatedStartDate();
  const endDate = formatedEndDate();

  if (!officeFilter && !costCenterFilter && !storehouseFilter && !startDate && !endDate) {
    return null
  }
  return (
    <StyledWrapper>
      <Form.Label>{t('employeesPage:activeFilter')}</Form.Label>
      <StyledItemWrapper>
      {!!officeFilter && (
          <StyledItem><b>{t('orgaUnitShortcut')}:</b> {officeName}<CloseButton onClick={() => { setOfficeFilter(null) }} /></StyledItem>
        )}
        {!!costCenterFilter && (
          <StyledItem><b>{t('costcenterShortcut')}:</b> {costCenterName} <CloseButton
            onClick={() => { setCostCenterFilter(null) }} /></StyledItem>
        )}
        {!!storehouseFilter && (
          <StyledItem><b>{t('returnsTable:warehouseShortcut')}:</b> {storehouseFilter.displayName} <CloseButton
            onClick={() => { setStorehouseFilter(null) }} /></StyledItem>
        )}
        {!!startDate && (
          <StyledItem><b>{t('from')}:</b> {startDate} <CloseButton
            onClick={() => { setStartDateFilter(null) }} /></StyledItem>
        )}
        {!!endDate && (
          <StyledItem><b>{t('to')}:</b> {endDate} <CloseButton
            onClick={() => { setEndDateFilter(null) }} /></StyledItem>
        )}
      </StyledItemWrapper>
    </StyledWrapper>
  )
}

export default ActiveTableFilters
